<template>
  <paper-modal-container :is-visible="isVisible" title="이용약관" :hide-close-button="false" @close="closeModal">
    <div :class="$style.termsContent">
      <div :class="$style.section">
        <p>
          본 약관은 링꾹라이브 (live.linkook.it, 이하 "사이트")가 제공하는
          서비스(이하 "서비스")의 이용과 관련하여 사이트와 이용자 간의 권리·의무
          및 책임사항을 규정합니다.
        </p>
      </div>

      <div :class="$style.section">
        <h3>1. 목적</h3>
        <p>
          이 약관은 이용자가 사이트에서 제공하는 서비스를 원활하고 공정하게
          이용할 수 있도록 기본적인 사항을 규정함을 목적으로 합니다.
        </p>
      </div>

      <div :class="$style.section">
        <h3>2. 회원가입 및 계정</h3>
        <ul>
          <li>
            이용자는 다음 방법을 통해 회원가입을 할 수 있습니다:
            <ul>
              <li>이메일 주소와 비밀번호를 이용한 직접 가입</li>
              <li>카카오 계정을 통한 소셜 로그인</li>
            </ul>
          </li>
          <li>회원은 자신의 계정을 타인에게 양도하거나 대여할 수 없습니다.</li>
          <li>
            회원가입 시 제공되는 개인정보는 개인정보 처리방침에 따라 관리됩니다.
          </li>
          <li>
            이메일 회원가입 시 제공하는 이메일 주소는 유효한 주소여야 하며, 계정
            관리 및 중요 안내를 위해 사용됩니다.
          </li>
          <li>
            가입된 회원은 프로필 화면에서 X(구 트위터) 계정을 연동하여 프로필
            정보 및 닉네임을 가져올 수 있습니다. 이는 로그인 목적이 아닌 프로필
            정보 동기화 목적으로만 사용됩니다.
          </li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>3. 서비스의 제공 및 변경</h3>
        <ul>
          <li>
            사이트는 이용자에게 공연 정보, 커뮤니티, 티켓 예매 및 기타 관련
            서비스를 제공합니다.
          </li>
          <li>
            서비스의 내용은 운영상, 기술상의 필요에 따라 변경될 수 있으며, 이
            경우 변경 내용을 사전에 공지합니다.
          </li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>4. 티켓 예매, 취소 및 환불</h3>
        <p>
          사이트를 통해 진행되는 행사(공연 등)의 예매 취소 및 환불에 대한 기본
          규정은 다음과 같습니다.
        </p>
        <ul>
          <li>행사 시작일 3일 전까지: 결제 금액 전액 환불</li>
          <li>행사 시작일 2일 전: 결제 금액의 70% 환불</li>
          <li>행사 시작일 1일 전 및 당일 이후: 환불 불가</li>
          <li>
            단, 행사를 주최하는 판매자(주최자)가 개별적으로 취소 및 환불 규정을
            정하여 예매 페이지에 명시한 경우, 해당 판매자의 개별 규정이 본 약관의
            기본 규정보다 우선하여 적용됩니다.
          </li>
          <li>
            플랫폼인 사이트는 판매자가 개별적으로 고지한 환불 규정과 관련하여
            발생한 예매자와 판매자 간의 분쟁에 대해 원칙적으로 책임을 지지
            않습니다.
          </li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>5. 이용자의 의무</h3>
        <p>이용자는 서비스를 이용함에 있어 다음 행위를 하여서는 안 됩니다.</p>
        <ul>
          <li>타인의 계정을 도용하는 행위</li>
          <li>법령 및 공공질서에 위반되는 행위</li>
          <li>사이트의 정상적인 운영을 방해하는 행위</li>
          <li>타인의 권리(저작권, 초상권 등)를 침해하는 행위</li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>6. 게시물 관리</h3>
        <ul>
          <li>
            이용자가 서비스 내에 작성한 게시물의 저작권은 원칙적으로 해당
            이용자에게 있습니다.
          </li>
          <li>
            사이트는 서비스 운영, 홍보, 개선을 위하여 필요한 범위 내에서
            이용자의 게시물을 활용할 수 있습니다.
          </li>
          <li>불법·부적절한 게시물은 사전 통보 없이 삭제될 수 있습니다.</li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>7. 서비스 이용 제한</h3>
        <p>
          이용자가 본 약관을 위반하거나 서비스 운영을 심각하게 방해할 경우,
          사이트는 이용자의 서비스 이용을 제한하거나 계정을 정지·탈퇴 처리할 수
          있습니다.
        </p>
      </div>

      <div :class="$style.section">
        <h3>8. 면책 조항</h3>
        <ul>
          <li>
            사이트는 천재지변, 시스템 장애, 제3자의 불법 행위 등으로 인해
            서비스를 제공할 수 없는 경우 책임을 지지 않습니다.
          </li>
          <li>
            이용자가 서비스 이용 과정에서 발생한 손해에 대해, 사이트의 고의 또는
            중대한 과실이 없는 한 책임을 지지 않습니다.
          </li>
        </ul>
      </div>

      <div :class="$style.section">
        <h3>9. 약관의 변경</h3>
        <p>
          사이트는 법령 개정이나 서비스 변경 등의 필요가 있을 경우 약관을 변경할
          수 있습니다. 변경된 약관은 사이트에 공지함으로써 효력을 가집니다.
        </p>
      </div>

      <div :class="$style.section">
        <h3>10. 준거법 및 관할</h3>
        <p>
          이 약관은 대한민국 법률에 따라 해석되며, 서비스 이용과 관련하여 발생한
          분쟁은 서울중앙지방법원을 전속 관할 법원으로 합니다.
        </p>
      </div>

      <div :class="$style.section">
        <p>공고일자: 2026년 3월 7일<br />시행일자: 2026년 3월 14일</p>
      </div>

      <div :class="$style.actions">
        <button :class="$style.closeButton" @click="closeModal">닫기</button>
      </div>
    </div>
  </paper-modal-container>
</template>

<script>
import PaperModalContainer from "@/components/modal/PaperModalContainer.vue";

export default {
  name: "TermsModal",
  components: {
    PaperModalContainer,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close"],
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style module>
.termsContent {
  text-align: left;
  max-width: 600px;
  margin: 0 auto;
}

.section {
  margin-bottom: 20px;
}

.section h3 {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  border-bottom: 2px solid #8e7f7f;
  padding-bottom: 5px;
}

.section p {
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 10px;
}

.section ul {
  color: #555;
  font-size: 14px;
  line-height: 1.6;
  /* margin-left: 20px; */
  margin-bottom: 10px;
}

.section li {
  margin-bottom: 5px;
}

.section strong {
  color: #333;
  font-weight: 600;
}

.actions {
  text-align: center;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.closeButton {
  background-color: #6f6f6f;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.closeButton:hover {
  background-color: #7a6b6b;
}

/* ========================================
   반응형 디자인
   - Large: 1025px ~ (기본 스타일)
   - Medium: 481px ~ 1024px
   - Small: ~ 480px
   ======================================== */

/* Medium (481px ~ 1024px) */
@media screen and (max-width: 1024px) {
  .termsContent {
    max-width: 100%;
    padding: 0 10px;
  }

  .section {
    margin-bottom: 18px;
  }

  .section h3 {
    font-size: 15px;
    margin-bottom: 8px;
    padding-bottom: 4px;
  }

  .section p,
  .section ul {
    font-size: 13px;
    line-height: 1.5;
  }

  .actions {
    margin-top: 25px;
    padding-top: 15px;
  }

  .closeButton {
    padding: 10px 25px;
    font-size: 13px;
  }
}

/* Small (~ 480px) */
@media screen and (max-width: 480px) {
  .termsContent {
    padding: 0 5px;
  }

  .section {
    margin-bottom: 15px;
  }

  .section h3 {
    font-size: 14px;
    margin-bottom: 6px;
    padding-bottom: 3px;
    border-bottom-width: 1.5px;
  }

  .section p,
  .section ul {
    font-size: 12px;
    line-height: 1.45;
    margin-bottom: 8px;
  }

  .section ul {
    margin-left: -15px;
    padding-left: 20px;
  }

  .section li {
    margin-bottom: 4px;
  }

  .actions {
    margin-top: 20px;
    padding-top: 12px;
  }

  .closeButton {
    padding: 8px 20px;
    font-size: 12px;
    border-radius: 5px;
  }
}
</style>
